export default [
  '😀',
  '😁',
  '😆',
  '😳',
  '😂',
  '😭',
  '😎',
  '😍',
  '😘',
  '😜',
  '😏',
  '🙄',
  '😔',
  '😷',
  '👻',
  '👽',
  '💋',
  '👌',
  '🤝',
  '🙏',
  '💪',
  '🧧',
  '💔',
  '❤',
  '💤',
  '🇨',
  '🎂',
  '🎁',
  '🥂',
  '🚚',
  '✈',
  '🍉',
  '🍊',
  '🍋',
  '🍍',
  '🥭',
  '🍎',
  '🍒',
  '🍓',
  '🍆',
  '🥔',
  '🥕',
  '🌶',
  '🥬',
  '🥦',
  '🍄',
  '🦀',
  '🦞'
]
